// export const USER_TOKEN = "USER_TOKEN";
export const HTTP_LOADING = "HTTP_LOADING";
export const SYSTEM_ID = "SYSTEM_ID";
export const ID = "ID";
// export const AUTH='AUTH';
export const BUSINESS = 'BUSINESS';
// export  const STAFF='STAFF';


// WEBPACK FOOTER //
// ./src/store/types.js